import React, { PureComponent } from 'react';
import { Row, Col, Form, FormGroup, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { isURL } from 'validator';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { bool, array, object, func } from 'prop-types';
import Card from '../../../../components/Card/Card';
import CustomControl from '../../../../components/CustomControl/CustomControl';
import FlowPostbackMethod from './FlowPostbackMethod';
import FlowPostbackUrl from './FlowPostbackUrl';
import FlowPostbackStatuses from './FlowPostbackStatuses';
import Hint from '../../../../components/Hint/Hint';
import GlobalPostbackPresets from './GlobalPostbackPresets';
import FaqContent from '../../../../components/Faq/FaqContent';
import { ThemedFMessage } from '../../../../hoc/IntlComponents';

const GLOBAL_USAGE_STATUS = 5;

class GlobalPostbackForm extends PureComponent {
  static propTypes = {
    statuses: array.isRequired,
    enabled: bool,
    loading: bool,
    postback: object,
    onCheckPostback: func.isRequired,
    onSubmit: func.isRequired,
  };

  static defaultProps = {
    statuses: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      enabled: true,
      data: {
        method: 0,
        url: '',
        statuses: [],
      },
    };
  }

  UNSAFE_componentWillReceiveProps({ loading, postback }) {
    if (!loading && postback && postback.url) {
      this.setState(prevState => ({
        enabled: !!postback.status,
        data: {
          ...prevState.data,
          method: postback.method,
          url: postback.url,
          statuses: postback['pixels_status'] || postback['pixels_status[]'] || [],
        },
      }));
    }
  }

  handleChange = data => {
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        ...data,
      },
    }));
  };

  onStatusChange = statuses => {
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        statuses,
      },
    }));
  };

  togglePostback = ({ target }) => {
    this.setState(() => ({ enabled: target.checked }));
  };

  toggleGlobalUsage = () => {
    const { statuses } = this.state.data;
    const index = statuses.indexOf(GLOBAL_USAGE_STATUS);

    if (index === -1) {
      statuses.push(GLOBAL_USAGE_STATUS);
    } else {
      statuses.splice(index, 1);
    }

    this.onStatusChange(statuses);
  };

  isValid = url => url === '' || isURL(url, { require_protocol: true });

  handleSubmit = e => {
    e.preventDefault();

    if (this.state.enabled) {
      const { url = '', method = 0, statuses = [] } = this.state.data;

      this.props.onSubmit({
        status: 1,
        url,
        method,
        'pixels_status[]': statuses,
      });
    } else {
      this.props.onSubmit({ status: 0 });
    }
  };

  onPresetApply = url => {
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        url,
      },
    }));
  };

  isValidUrl = url => isURL(url);

  render() {
    const { enabled, data } = this.state;
    const { loading, statuses, theme, page } = this.props;
    const globalUsageEnabled = data.statuses.indexOf(GLOBAL_USAGE_STATUS) !== -1;

    return (
      <Form className="global-postback-form" onSubmit={this.handleSubmit}>
        <Card loading={loading}>
          <Card.Body>
            <Row>
              <Col lg="6" md='8'>
            <FormGroup className="postback-enable">
              <Col lg='3' xl='3'>
                {/* <CustomControl
                id="global-postback"
                className="custom-control-xs no-margin"
                label={
                  <span>
                    <FormattedMessage
                      id="postback.global.enable"
                      defaultMessage="Enable global postback"
                    />
                    <Hint id="global-postback-hint" placement="right" delay={250}>
                  <FormattedHTMLMessage
                      id="postback.global.hint-1"
                      defaultMessage="A&nbsp;global postback is&nbsp;an&nbsp;additional parameter, which lets you
                      collecting information about every conversion you&rsquo;ve made and aggregate your
                      very own statistics via self-hosted statistics systems or&nbsp;third-party
                      trackers."
                      tagName="p"
                    />
                    <FormattedHTMLMessage
                      id="postback.global.hint-2"
                      defaultMessage="When our statistics tracks a&nbsp;conversion, the system will send GET
                      or&nbsp;POST request to&nbsp;the url you specified in&nbsp;&laquo;Postback
                      URL&raquo; parameter."
                      tagName="p"
                    />
                </Hint>
                  </span>
                }
                value="1"
                onChange={this.togglePostback}
                checked={enabled}
                inline
              >
                
              </CustomControl> */}

              
              </Col>
              
              <Col lg='9'>
              <Button
                type="button"
                color="primary"
                size='sm'
                onClick={() => this.props.onCheckPostback(data)}
                disabled={!this.isValidUrl(data.url)}
              >
                <ThemedFMessage id="flow.form.postback.check" />
              </Button>
              </Col>
            </FormGroup>

            {enabled && <GlobalPostbackPresets onPresetApply={this.onPresetApply}/>}

            <fieldset disabled={!enabled}>
                  <FlowPostbackUrl
                    url={data.url}
                    onUrlChange={this.handleChange}
                    onCheckPostback={() => this.props.onCheckPostback(data)}
                  />
                  <FlowPostbackMethod
                    selectedMethod={data.method}
                    onPostbackMethodChange={this.handleChange}
                  />

            
              <FormGroup className='statuses'>
                    <FlowPostbackStatuses
                      statuses={statuses}
                      selected={data.statuses}
                      onStatusChange={this.onStatusChange}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Col lg={{ size: '8', offset: '4' }}>
                      <CustomControl
                      id="global-usage"
                      className="custom-control-xs no-margin"
                    label={
                        <span>
                        <FormattedMessage
                          id="postback.global.use-for-all"
                          defaultMessage="Use for all flows"
                        />

                        <Hint id="global-postback-usage" placement="right" delay={250}>
                      <FormattedMessage
                        id="postback.global.use-for-all.hint"
                        defaultMessage="The global postback will be working on every flow you created, disabling
                          settings of postback you specified in the flow before"
                      />
                        </Hint>
                      </span>
                      }
                      value="1"
                      onChange={this.toggleGlobalUsage}
                      checked={globalUsageEnabled}
                      inline
                      />
                      <Col xs='12'>
                      <Button
                        className='mt-4'
                      size="sm"
                      color="primary"
                      disabled={loading || !this.isValid(data.url)}
                    >
                      <FormattedMessage id="main.apply" defaultMessage="Apply" />
                        </Button>
                      </Col>
                    </Col>
                  </FormGroup>
              
              </fieldset>
            </Col>
            <Col lg='6' md='4' className='postback-form-faq'>
                <FaqContent page={page} />
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* <Row>
          <Col>
            <FormGroup>
              <Button
                className="btn-lead"
                size="lg"
                color="primary"
                disabled={loading || !this.isValid(data.url)}
              >
                <FormattedMessage id="main.save" defaultMessage="Save" />
              </Button>
            </FormGroup>
          </Col>
        </Row> */}
      </Form>
    );
  }
}

export default GlobalPostbackForm;
